import { Suspense } from 'react';
import Footer from './Footer';
import PaymentMethodResultModal from './PaymentMethodResultModal';
import { Layout as ApplicationLayout, useAuth } from '@increasecard/increase-core';
import { usePayAccount } from '../hooks/usePayAccount';
import styled from 'styled-components';
import LoadingIndicator from './LoadingIndicator';
import I18nLoader from './I18nLoader';
import { Routes } from '../containers/Routes';
import { NavBar } from './NavBar/NavBar';

// const tabs = (history: History, t: TFunction, userCountry: Country): TabList => {
//   const a: TabList = [
//     {
//       as: 'button',
//       onClick: () => history.push(routes.platform.home),
//       name: t('common:home'),
//       active: history.location.pathname === routes.platform.home,
//     },
//     {
//       as: 'button',
//       onClick: () => history.push(routes.platform.settings.user),
//       name: t('common:account'),
//       active: history.location.pathname.startsWith(routes.platform.settings.user),
//     },
//     {
//       as: 'button',
//       onClick: () => history.push(routes.invoices.index),
//       name: t('common:billing'),
//       active: history.location.pathname.startsWith(routes.invoices.index),
//     },
//     {
//       as: 'button',
//       onClick: () => history.push(routes.advanced.index),
//       name: t('common:advancedSettings'),
//       active: history.location.pathname.startsWith(routes.advanced.index),
//     },
//   ];
//   if (userCountry === 'ecuador') {
//     a.push({
//       as: 'button',
//       onClick: () => history.push(routes.payments),
//       name: t('common:payments'),
//       active: history.location.pathname.startsWith(routes.payments),
//     });
//   }
//   if (t('resources:myRequestsLink')) {
//     a.push({
//       as: 'button',
//       onClick: () => history.push(routes.support),
//       name: t('resources:myRequests'),
//       active: history.location.pathname.startsWith(routes.support),
//     });
//   }
//   return a;
// };

const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: 1fr auto;
  gap: 0px;
  overflow: hidden;

  .content-outlet {
    background-color: var(--color-gray-graySLight);
    flex: 1;
    padding: 1rem 1.5rem;
    overflow-y: auto;
  }
  .footer {
    grid-column: span 2 / span 2;
  }
`;

export function Layout() {
  useAuth({ requireAuth: true });

  const { payAccount } = usePayAccount();

  return (
    <ApplicationLayout tabs={null} profileImageUrl={payAccount?.branding_settings?.icon_url}>
      <PaymentMethodResultModal />
      <ContentWrapper>
        <NavBar />
        <div className="content-outlet">
          <Suspense fallback={<LoadingIndicator />}>
            <I18nLoader>
              <Routes />
            </I18nLoader>
          </Suspense>
        </div>
        <Footer />
      </ContentWrapper>
    </ApplicationLayout>
  );
}
